import { render } from "./AddressTitle.vue?vue&type=template&id=1836e131"
import script from "./AddressTitle.vue?vue&type=script&lang=js"
export * from "./AddressTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__